///<reference path="../common/smart-mover.models.ts"/>
///<reference path="../common/filter-criteria.ts"/>


module Meevo.Components.Controls.SmartMover {
    import ObjectStateEnum = Meevo.Model.ObjectStateEnum;

    export class TerminatedCriteriaFilter extends CriteriaFilter implements ICriteriaFilter {
        public readonly templateName: FilterTemplateNames;
        public readonly values: { hideTerminated: boolean; };
        public readonly criteria: { IsEmployeeTerminated: boolean };

        constructor(collections: IApiCollection<any>[], options: IDataTemplateFilterOptions = {}) {
            super(collections, options);

            this.templateName = 'terminated';
            this.values = {
                hideTerminated: true
            };
        }

        updateCriteria() {
            this.criteria.IsEmployeeTerminated = this.values.hideTerminated;
        }
    }
}